module.exports = __webpack_public_path__ + "img/rotateLogo.a1f2b4f0.png";